<template>
<header>
  <div class="logo_Row">
  <div class="langSelect" v-if="languages.length > 1">
    <span v-for="lang in languages" v-bind:key="lang.code" v-bind:class="{disabled: lang.code == disabled_Lang}">
      <router-link v-if="lang.code != 'en'" :to="{ name: 'Menu', params: {boutique: boutique_id}, query: {lang: lang.code}}">
          {{ lang.code }}
      </router-link>
      <router-link v-if="lang.code == 'en'" :to="{ name: 'Menu', params: {boutique: boutique_id}}">
          {{ lang.code }}
      </router-link>
    </span>
  </div>
    <a href="#" v-scroll-to="'#top'">
      <img class="ap_Logo" src="/img/audemars_piguet_logo.png" />
    </a>
  </div>
  <nav v-if="navAvail">
    <ul>
      <li v-for="section in btqMenu" v-bind:key="section.id">
          <a href="#" v-scroll-to="'#' + _.kebabCase(section.title)">
            {{ section.title }}
          </a>
      </li>
    </ul>
  </nav>
</header>
</template>
<script>
export default {
  name: 'Topbar',
  props: {
    navAvail: Boolean,
    btqMenu: Array,
    languages: Array
  },
  methods: {

  },
  computed: {
    lang_id(){
      return this.$route.query.lang
    },
    boutique_id(){
      return this.$route.params.boutique;
    },
    disabled_Lang(){
      let lang = this.$route.query.lang;
      if (this._.isUndefined(lang) || lang == "" || lang == null){
        lang = "en";
      }
      return lang
    }
  }

}
</script>
